import React from 'react';
import { Text } from '@chakra-ui/react';
import ResponsiveInnerPanel from './ResponsiveInnerPanel';
import ResponsiveStack from './ResponsiveStack';
import PanelContainerWithFallback from './PanelContainerWithFallback';
import { localise } from '../../../services/lang/lang';
const LocationPanel = ({ location }) => (React.createElement(ResponsiveInnerPanel, { "data-testid": "location_panel", size: "small" },
    React.createElement(ResponsiveStack, null,
        React.createElement(PanelContainerWithFallback, { condition: true, title: `${localise('LOCATION')}:` },
            React.createElement(Text, { variant: "md-600-rg-4", "data-testid": "finding-panel__location-name", wordBreak: "keep-all", whiteSpace: "normal" }, location.display_name)))));
export default LocationPanel;
